import { render, staticRenderFns } from "./ProjectDetailHeader.vue?vue&type=template&id=36b5a41b&scoped=true"
import script from "./ProjectDetailHeader.vue?vue&type=script&lang=js"
export * from "./ProjectDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailHeader.vue?vue&type=style&index=0&id=36b5a41b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5a41b",
  null
  
)

export default component.exports